import Button from './button.view';

export default () => {
  return {
    restrict: 'A',
    link: function($scope, $element, $attributes) {
      let diagram = $scope.$eval($attributes.diagram);
      diagram.registerButton(new Button($element));
    }
  };
};



// WEBPACK FOOTER //
// ./client/app/components/tree-diagram/button.directive.js